import { getCurrentUrl, Link } from 'preact-router'
import { useCallback } from 'preact/hooks'
import config from '../Config.js'
import { useLocale, useTitle, useVersion } from '../contexts/index.js'
import { cleanUrl, getGenerator, SOURCE_REPO_URL } from '../Utils.js'
import { FancyMenu } from './FancyMenu.jsx'
import { searchGenerators } from './generator/GeneratorList.jsx'
import { Icons, Octicon } from './index.js'

export function Header() {
	const { locale } = useLocale()
	const { title } = useTitle()
	const url = getCurrentUrl()
	const gen = getGenerator(url)

	return <header>
		<div class="title flex items-center">
			{gen
				? <GeneratorTitle title={title} />
				: <h1 class="font-bold px-1 text-lg sm:text-2xl">{title}</h1>}
		</div>
		<nav>
			<ul>
				<li class="dimmed">
					<a href="https://ko-fi.com/misode" target="_blank" rel="noreferrer" class="flex items-center gap-1 no-underline">
						{Octicon.heart}<span>개발자에게 후원</span>
					</a>
				</li>
				<li class="dimmed">
					<a href={SOURCE_REPO_URL} target="_blank" rel="noreferrer" class="tooltipped tip-sw" aria-label={locale('github')}>
						{Octicon.mark_github}
					</a>
				</li>
			</ul>
		</nav>
	</header>
}

interface GeneratorTitleProps {
	title: string
}
function GeneratorTitle({ title }: GeneratorTitleProps) {
	const { locale } = useLocale()
	const { version } = useVersion()

	const getGenerators = useCallback((search: string, close: () => void) => {
		let results = config.generators
			.filter(g => !g.dependency)
			.map(g => ({ ...g, name: locale(`generator.${g.id}`).toLowerCase() }))
		results = searchGenerators(results, search)
		if (results.length === 0) {
			return [<span class="note">{locale('generators.no_results')}</span>]
		}
		return results.map(g =>
			<Link class="flex items-center cursor-pointer no-underline rounded p-1" href={cleanUrl(g.url)} onClick={close}>
				{locale(`generator.${g.id}`)}
				{Object.keys(Icons).includes(g.id) ? Icons[g.id as keyof typeof Icons] : undefined}
				<div class="m-auto"></div>
				{g.tags?.filter(t => t === 'assets').map(t =>
					<div class="badge ml-2 mr-0 text-sm" style="--color: #555;">{t}</div>
				)}
			</Link>
		)
	}, [locale, version])

	return <FancyMenu getResults={getGenerators} placeholder={locale('generators.search')}>
		<h1 class="font-bold flex items-center cursor-pointer text-lg sm:text-2xl">
			{title}
		</h1>
	</FancyMenu>
}
